import {Radio, RadioChangeEvent, Space} from 'antd';
import React from 'react';

import {Text} from '../../../../../../component/text/text';
import {useDocumentationLinks} from '../../../../../../provider/help-links/help-links-hook';
import {Locale} from '../../../../../../provider/locale/localization';
import {ExportFileFormatEnum} from '../feed-export-page-type';

import * as styles from './data-type.scss';

type PropsType = {
    value: ExportFileFormatEnum;
    onChange: (value: ExportFileFormatEnum) => void;
};

export function DataType(props: PropsType): React.JSX.Element {
    const {value, onChange} = props;
    const documentationLinks = useDocumentationLinks();

    return (
        <Space direction="vertical">
            <div className={styles.DataType_wrapper}>
                <Text bolder secondary small stringKey="FEED__FORM__FORMAT__LABEL" />
                <Radio.Group onChange={(event: RadioChangeEvent) => onChange(event.target.value)} value={value}>
                    <Radio value={ExportFileFormatEnum.Csv}>
                        <Locale stringKey="FEED__EXPORT__COMPANY_DATA_TYPE__CSV" />
                    </Radio>
                    <Radio value={ExportFileFormatEnum.Xlsx}>
                        <Locale stringKey="FEED__EXPORT__COMPANY_DATA_TYPE__EXCEL" />
                    </Radio>
                </Radio.Group>
            </div>
            {documentationLinks.company.feedExport && (
                <Text
                    stringKey="FEED__EXPORT__COMPANY_DATA_TYPE__HELP"
                    valueMap={{
                        link: (
                            <a href={documentationLinks.company.feedExport} rel="noreferrer" target="_blank">
                                <Locale stringKey="FEED__TEMPLATE_LINKS__HELP_LINK" />
                            </a>
                        ),
                    }}
                />
            )}
        </Space>
    );
}
